<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ForgotPasswordForm from "@/components/ForgotPasswordForm.vue";

export default {
  name: "ForgotPassword",
  title: "Forgot Password",
  page: {
    title: "Forgot Password",
    meta: [{ name: "description", content: "Forgot Password" }],
  },
  components: {
    Header,
    Footer,
    ForgotPasswordForm,
  },
};
</script>
<template>
  <main>
    <Header />
    <div class="content page-forgot">
      <ForgotPasswordForm />
    </div>
    <Footer />
  </main>
</template>
<style lang="scss">
.page-forgot {
  width: 100%;
}
.content {
  padding-bottom: 10%;
}
</style>